import ContentCard from "../../ui/ContentCard";
import ContentCardTitle from "../../ui/ContentCardTitle";
import styles from "../../styles/Components/bot/BotOverview.module.css";
import { RiRobot2Line } from "react-icons/ri";
import BotOverviewContent from "./bot-overview/BotOverviewContent";
import CreateBot from "./CreateBot";
import RequestBacktest from "./bot-backtest/RequestBacktest";

function BotOverview() {

  return (
    <ContentCard>
      <div className={styles.header}>
        <div className={styles.leftHeader}>
          <div className={styles.botIcon}>
            <RiRobot2Line color="#0D4AF9" size={23} />
          </div>
          <ContentCardTitle
            title="Bot Overview"
            style={{ display: "inline-block" }}
          />
        </div>
        <div className={styles.rightHeader}>
          <RequestBacktest
            title="Start a Backtest"
            className={`${styles.btn} ${styles.backtestBtn}`}
          />
          {/*<span className={`${styles.btn} ${styles.backtestBtn}`}>*/}
          {/*  {isBotActive ? <TbBrain /> : <FiLock />}*/}
          {/*  Start a Backtest*/}
          {/*</span>*/}
          {/*<span className={`${styles.btn} ${styles.createBtn}`}>*/}
          {/*  {isBotActive ? <FiPlus /> : <FiLock />}*/}
          {/*  Start New Bot*/}
          {/*</span>*/}
          <CreateBot className={`${styles.btn} ${styles.createBtn}`} />
        </div>
      </div>

      <BotOverviewContent />
    </ContentCard>
  );
}

export default BotOverview;
